import Vue from 'vue' // Include Vue
import Router from 'vue-router' // Include Vue Router libary
import App from './App.vue' // <--- We'll look at these in a moment
import CfgDiffView from './components/DiffView/CfgDiffView.vue'
import CfgView from './components/CfgView.vue'
import L1SeedsView from './components/L1SeedsView.vue'

Vue.use(Router)

export default new Router({
  mode: 'history', // <----
  routes: [
    {
      path: '/open',
      component: CfgView,
    },
    {
      path: '/',
      component: CfgView,
    },
    {
      path: '/diff',
      component : CfgDiffView,
      props: route => ({ to_cfg : route.query.to_cfg, from_cfg : route.query.from_cfg})
    },
    {
      path: '/l1seeds',
      component : L1SeedsView,
      props: route => ({ cfg : route.query.cfg})
    },
  ],
})
